/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AssessmentResults
 */
export interface AssessmentResults {
  /**
   *
   * @type {Array<Array<number>>}
   * @memberof AssessmentResults
   */
  performance: Array<Array<number>>;
  /**
   *
   * @type {Array<Array<number>>}
   * @memberof AssessmentResults
   */
  robustness: Array<Array<number>>;
  /**
   *
   * @type {Array<Array<number>>}
   * @memberof AssessmentResults
   */
  fairness: Array<Array<number>>;
  /**
   *
   * @type {Array<Array<number>>}
   * @memberof AssessmentResults
   */
  explainability: Array<Array<number>>;
  /**
   *
   * @type {Array<Array<number>>}
   * @memberof AssessmentResults
   */
  performanceProbability: Array<Array<number>>;
  /**
   *
   * @type {Array<Array<number>>}
   * @memberof AssessmentResults
   */
  robustnessProbability: Array<Array<number>>;
  /**
   *
   * @type {Array<Array<number>>}
   * @memberof AssessmentResults
   */
  fairnessProbability: Array<Array<number>>;
  /**
   *
   * @type {Array<Array<number>>}
   * @memberof AssessmentResults
   */
  explainabilityProbability: Array<Array<number>>;
}

/**
 * Check if a given object implements the AssessmentResults interface.
 */
export function instanceOfAssessmentResults(value: object): value is AssessmentResults {
  if (!('performance' in value) || value['performance'] === undefined) return false;
  if (!('robustness' in value) || value['robustness'] === undefined) return false;
  if (!('fairness' in value) || value['fairness'] === undefined) return false;
  if (!('explainability' in value) || value['explainability'] === undefined) return false;
  if (!('performanceProbability' in value) || value['performanceProbability'] === undefined) return false;
  if (!('robustnessProbability' in value) || value['robustnessProbability'] === undefined) return false;
  if (!('fairnessProbability' in value) || value['fairnessProbability'] === undefined) return false;
  if (!('explainabilityProbability' in value) || value['explainabilityProbability'] === undefined) return false;
  return true;
}

export function AssessmentResultsFromJSON(json: any): AssessmentResults {
  return AssessmentResultsFromJSONTyped(json, false);
}

export function AssessmentResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentResults {
  if (json == null) {
    return json;
  }
  return {
    performance: json['performance'],
    robustness: json['robustness'],
    fairness: json['fairness'],
    explainability: json['explainability'],
    performanceProbability: json['performance_probability'],
    robustnessProbability: json['robustness_probability'],
    fairnessProbability: json['fairness_probability'],
    explainabilityProbability: json['explainability_probability'],
  };
}

export function AssessmentResultsToJSON(value?: AssessmentResults | null): any {
  if (value == null) {
    return value;
  }
  return {
    performance: value['performance'],
    robustness: value['robustness'],
    fairness: value['fairness'],
    explainability: value['explainability'],
    performance_probability: value['performanceProbability'],
    robustness_probability: value['robustnessProbability'],
    fairness_probability: value['fairnessProbability'],
    explainability_probability: value['explainabilityProbability'],
  };
}
